import { NavLink, Outlet, useLocation } from "react-router-dom";
import { LayoutGrid, Files, Settings as SettingsIcon, Ruler, LogOut, CalendarDays, Users, ListChecks, Package } from "lucide-react";
import { logout } from "@/lib/api";

const navItems = [
  { to: "/", label: "Upload", icon: LayoutGrid, testid: "nav-upload" },
  { to: "/quotes", label: "Quotes", icon: Files, testid: "nav-quotes" },
  { to: "/customers", label: "Customers", icon: Users, testid: "nav-customers" },
  { to: "/schedule", label: "Workshop", icon: CalendarDays, testid: "nav-schedule" },
  { to: "/day-plans", label: "Day plans", icon: ListChecks, testid: "nav-day-plans" },
  { to: "/packing-lists", label: "Packing", icon: Package, testid: "nav-packing-lists" },
  { to: "/settings", label: "Pricing", icon: SettingsIcon, testid: "nav-settings" },
];

const Layout = () => {
  const location = useLocation();
  const inReview = location.pathname === "/review";

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-white print:min-h-0 print:block">
      {/* Sidebar */}
      <aside
        className="md:w-[240px] md:min-h-screen border-b md:border-b-0 md:border-r border-zinc-200 bg-white flex md:flex-col flex-row items-stretch print:hidden"
        data-testid="sidebar"
      >
        <div className="p-6 border-b border-zinc-200 flex items-center gap-3 md:w-full">
          <div className="w-8 h-8 bg-[#09090b] text-white flex items-center justify-center">
            <Ruler size={16} />
          </div>
          <div>
            <div className="font-display text-lg font-black leading-none tracking-tighter">
              SCREEN/01
            </div>
            <div className="label-xs mt-1">Pricing Bureau</div>
          </div>
        </div>
        <nav className="flex md:flex-col flex-row md:p-3 p-2 gap-1 md:gap-0 flex-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={item.testid}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 border text-xs uppercase tracking-[0.18em] font-semibold transition-colors ${
                    isActive ||
                    (inReview && item.to === "/")
                      ? "bg-[#09090b] text-white border-[#09090b]"
                      : "bg-white text-[#09090b] border-transparent hover:bg-zinc-100 md:border-transparent"
                  }`
                }
              >
                <Icon size={14} />
                <span className="hidden md:inline">{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <div className="hidden md:block p-4 border-t border-zinc-200">
          <div className="label-xs">System</div>
          <div className="font-mono text-[11px] text-zinc-600 mt-2 leading-relaxed">
            v1.0 · mm · m²
            <br />
            Gemini Vision OCR
          </div>
          <button
            type="button"
            onClick={logout}
            data-testid="nav-logout"
            className="mt-4 w-full flex items-center gap-2 px-3 py-2 border border-zinc-200 text-[10px] uppercase tracking-[0.18em] font-semibold text-zinc-600 hover:bg-zinc-100 hover:text-[#09090b] transition-colors"
          >
            <LogOut size={12} />
            Lock
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
